import { isMacOS } from '@/utils/is-macos';
import { PTTBinding } from '@/types/ptt-binding';

const BINDING_STORAGE_KEY = 'ptt-binding';

export function loadPTTBinding(): PTTBinding {
  const raw = localStorage.getItem(BINDING_STORAGE_KEY);
  if (raw) return JSON.parse(raw);

  return {
    type: 'keyboard',
    code: isMacOS ? 'Space' : 'CapsLock',
  };
}

export function savePTTBinding(binding: PTTBinding) {
  localStorage.setItem(BINDING_STORAGE_KEY, JSON.stringify(binding));
}